import { jsonToQuery } from "../../utils/ServicesUtils";
import { doFetch, REQUEST_METHODS } from "../fetcher";

export default {
  generateAccessToken: (query) =>
    doFetch(`/companyAdminProxy/generateAccessToken${jsonToQuery(query)}`, {
      method: REQUEST_METHODS.POST,
    }),
  getDataStreamConfig: (query) =>
    doFetch(
      `/companyAdminProxy/getDataStreamConfigInfoByCompany${jsonToQuery(query)}`,
      {
        method: REQUEST_METHODS.GET,
      }
    ),
};
